export default __webpack_public_path__ + "assets/images/square-0185c4b70ad21386d4489b91625d94d3.svg";